import { render, staticRenderFns } from "./DocumentChecklist2.vue?vue&type=template&id=4cb4f718&scoped=true&"
import script from "./DocumentChecklist2.vue?vue&type=script&lang=js&"
export * from "./DocumentChecklist2.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChecklist2.vue?vue&type=style&index=0&id=4cb4f718&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4f718",
  null
  
)

export default component.exports